import { ILienholder, ILienholderAddress } from '../../interfaces';

export type TLienholderValues = {
  lienholder_name: string;
  address_line1: string;
  address_line2?: string;
  address_city: string;
  address_postal: string;
  address_region: string;
};

export default function getLienholderObject(
  {
    lienholder_name,
    address_line1,
    address_line2,
    address_city,
    address_postal,
    address_region,
  }: TLienholderValues,
  { isPolicyUpdate }: { isPolicyUpdate?: boolean } = {}
): ILienholder | null {
  if (address_line1 && address_city && address_region && address_postal) {
    const baseAddress = {
      line1: address_line1,
      line2: null,
      city: address_city,
      region: {
        code: address_region,
        name: address_region,
      },
      postal: address_postal,
      country: isPolicyUpdate
        ? { alpha2: 'US', name: 'United States' }
        : {
            code: 'US',
            name: 'United States',
          },
    };

    const address: ILienholderAddress = address_line2
      ? {
          ...baseAddress,
          line2: address_line2,
        }
      : baseAddress;

    return {
      name: lienholder_name,
      address,
    };
  }
  if (lienholder_name) {
    return { name: lienholder_name, address: null };
  }
  return null;
}
